import React, { useState, useEffect } from "react";

import "./styles/layerfilter.css";
import "./styles/logos.css";
import { ReactComponent as HelpLogo } from "../logos/help.svg";
import { ReactComponent as InfoLogo } from "../logos/info.svg";
import { ReactComponent as ViolationLogo } from "../logos/violation.svg";
import { ReactComponent as CovidReportingLogo } from "../logos/covid_reporting.svg";

const SeconderyButtons = ({
  checkButtonPress,
  selectedButtonId,
  flyOverData,
}) => {
  return (
    <div className="secondery-b-container">
      <span>
        <button
          className={
            selectedButtonId === "help"
              ? "path2logo-active"
              : "path2logo-deafult"
          }
          onClick={() => checkButtonPress("help")}
        >
          <HelpLogo className="logo" />
        </button>
        <i>
          {flyOverData["106help"] && selectedButtonId === "help" ? (
            flyOverData["106help"]
          ) : (
            <br />
          )}
        </i>
      </span>
      <span>
        <button
          className={
            selectedButtonId === "info"
              ? "path2logo-active"
              : "path2logo-deafult"
          }
          onClick={() => checkButtonPress("info")}
        >
          <InfoLogo className="logo" />
        </button>
        <i>
          {flyOverData["106info"] && selectedButtonId === "info" ? (
            flyOverData["106info"]
          ) : (
            <br />
          )}
        </i>
      </span>
      <span>
        <button
          className={
            selectedButtonId === "violation"
              ? "path2logo-active polygon1logo-active"
              : "path2logo-deafult polygon1logo-deafult"
          }
          onClick={() => checkButtonPress("violation")}
        >
          <ViolationLogo className="logo" />
        </button>
        <i>
          {flyOverData["106violation"] && selectedButtonId === "violation" ? (
            flyOverData["106violation"]
          ) : (
            <br />
          )}
        </i>
      </span>
      <span>
        <button
          className={
            selectedButtonId === "covidReport"
              ? "path3logo-active"
              : "path3logo-deafult"
          }
          onClick={() => checkButtonPress("covidReport")}
        >
          <CovidReportingLogo className="logo" />
        </button>
        <i>
          {flyOverData["covidReport"] && selectedButtonId === "covidReport" ? (
            flyOverData["covidReport"]
          ) : (
            <br />
          )}
        </i>
      </span>
    </div>
  );
};

export default SeconderyButtons;
